export default __webpack_public_path__ + "static/media/44.f6f9d5ba.jpeg";